import React from "react";
import { SvgIcon } from "@material-ui/core";

const EditIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M9.62891 2.86914L13.129 6.36921" strokeMiterlimit="10" />
      <path
        d="M5.20009 14.3L1 15L1.70001 10.7999L11.09 1.40991C11.3526 1.14744 11.7086 1 12.0798 1C12.4511 1 12.8071 1.14744 13.0697 1.40991L14.5901 2.93034C14.8526 3.19289 15 3.54893 15 3.92016C15 4.2914 14.8526 4.64744 14.5901 4.90998L5.20009 14.3Z"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </SvgIcon>
  );
};

export default EditIcon;
